import React, { useEffect, useState } from 'react';
import { Sparkles, TrendingUp } from 'lucide-react';
import axios from 'axios';

/**
 * Lightweight social-proof strip shown above /browse and on the landing page.
 * Pulls real signup counts from /api/public/recent-signups with a polite floor
 * so it never reads as "0 joined this week" on a fresh database.
 * Public endpoint — no auth, safe to render before login.
 */
const SocialProofBanner = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    const url = `${process.env.REACT_APP_BACKEND_URL || ''}/api/public/recent-signups`;
    axios.get(url).then((r) => setStats(r.data)).catch(() => {});
  }, []);

  if (!stats) return null;

  return (
    <div
      data-testid="social-proof-banner"
      className="flex items-center gap-3 px-4 py-2.5 mb-4 rounded-full bg-gradient-to-r from-fnl-pink/15 via-fuchsia-500/10 to-fnl-pink/15 border border-fnl-pink/30 text-purple-100 text-sm overflow-hidden"
    >
      <TrendingUp className="w-4 h-4 text-fnl-pink shrink-0" />
      <span className="truncate">
        <span className="font-bold text-fnl-pink">{stats.this_week}</span> new members joined this week
        <span className="hidden sm:inline text-purple-300"> · {stats.total}+ singles on Flirty 🔥</span>
      </span>
      <Sparkles className="w-4 h-4 text-fuchsia-300 ml-auto shrink-0 animate-pulse" />
    </div>
  );
};

export default SocialProofBanner;
